import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@envs/environment';

@Injectable()
export class AppTokenInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (req.url.startsWith('https://accounts.google.com')) {
      return next.handle(req);
    }

    const clonedReq = req.clone({
      setHeaders: {
        'X-App-Token': environment.appToken,
      },
    });

    return next.handle(clonedReq);
  }
}
